import i18n from '@/i18n'
import { gm } from './gm'

const jsjky = () => import('@/components/firms/jsjky.vue')
const jhhx = () => import('@/components/firms/jhhx.vue')
const dfyh = () => import('@/components/firms/dfyh.vue')
const jsqt = () => import('@/components/firms/jsqt.vue')
const shsk = () => import('@/components/firms/shsk.vue')
const hdjs = () => import('@/components/firms/hdjs.vue')
const yajs = () => import('@/components/firms/yajs.vue')
const jgs = () => import('@/components/firms/jgs.vue')
const zyf = () => import('@/components/firms/zyf.vue')
const yjjt = () => import('@/components/firms/yjjt.vue')
const jsjs = () => import('@/components/firms/jsjs.vue')
const btkj = () => import('@/components/firms/btkj.vue')
const kld = () => import('@/components/firms/kld.vue')
const jlkj = () => import('@/components/firms/jlkj.vue')
export const groupMap = {
    f0: jsjky, // 姹熻嫃寤虹闄?1
    f1: jhhx, //姹熸捣鏉惂 1
    f2: dfyh, //涓滄柟闆ㄨ櫣1
    f3: jsqt,    //姹熻嫃鎿庡ぉ宸ヤ笟浜掕仈缃戞湁闄愬叕鍙哥畝浠?1
    f4: shsk, //涓婃捣鍦ｅ 1
    f5: hdjs, //瀹忓ぇ寤鸿 1
    f6: yajs,// 姹熻嫃瀹滃畨寤鸿 1
    f7: jgs, // 浣冲浐澹?1
    f8: zyf, // 涓嚎涓?1
    f9: yjjt, // 姹熻嫃鎵缓 1
    f10: jsjs, // 姹熻嫃閿︿笂 1
    f11: btkj, // 鍗椾含璐濆攼銆€锛?    f12: jlkj, // 涔呯摯绉戞妧
    f13: kld, // 涔呯摯绉戞妧
    f14: () => import('@/components/firms/26du/index.vue'),
    f15: () => import('@/components/firms/gdw/index.vue'),
    f16: () => import('@/components/firms/gwjs/index.vue'),
    f17: () => import('@/components/firms/jsjzzyxy/index.vue'),
    f18: () => import('@/components/firms/jslx/index.vue'),
    f19: () => import('@/components/firms/jpyl/index.vue'),
    f20: () => import('@/components/firms/elematic/index.vue'),
    f21: () => import('@/components/firms/dv/index.vue'),
    f22: () => import('@/components/firms/bjaq/index.vue'),
    f23: () => import('@/components/firms/hbok/index.vue'),
    f24: () => import('@/components/firms/kdgj/index.vue'),
    f25: () => import('@/components/firms/kldtl/index.vue'),
    f26: () => import('@/components/firms/lczg/index.vue'),
    f27: () => import('@/components/firms/kbd/index.vue'),
    f28: () => import('@/components/firms/meb/index.vue'),
    f29: () => import('@/components/firms/bhbl/index.vue'),
    f30: () => import('@/components/firms/cztj/index.vue'),
    f31: () => import('@/components/firms/dlly/index.vue'),
    f32: () => import('@/components/firms/jssw/index.vue'),
    f33: () => import('@/components/firms/jywy/index.vue'),
    f34: () => import('@/components/firms/jykj/index.vue'),
    f35: () => import('@/components/firms/jbh/index.vue'),
    f36: () => import('@/components/firms/jlz/index.vue'),
    f37: () => import('@/components/firms/klsk/index.vue'),
    f38: () => import('@/components/firms/nthy/index.vue'),
    f39: () => import('@/components/firms/wxlr/index.vue'),
    f40: () => import('@/components/firms/wxxzh/index.vue'),
    f41: () => import('@/components/firms/nths/index.vue'),
    f42: () => import('@/components/firms/jssx/index.vue'),
    f43: () => import('@/components/firms/hxnj/index.vue'),
    f44: () => import('@/components/firms/jsjr/index.vue'),
    f45: () => import('@/components/firms/sjzxy/index.vue'),
    f46: () => import('@/components/firms/sghjt/index.vue'),
    f47: () => import('@/components/firms/dgsp/index.vue'),
    f48: () => import('@/components/firms/szjz/index.vue'),
    f49: () => import('@/components/firms/szxy/index.vue'),
    f50: () => import('@/components/firms/szylsj/index.vue'),
    f51: () => import('@/components/firms/tsbq/index.vue'),
    f52: () => import('@/components/firms/z52/index.vue'),
    f53: () => import('@/components/firms/z53/index.vue'),
    f54: () => import('@/components/firms/z54/index.vue'),
    f55: () => import('@/components/firms/z55/index.vue'),
    f56: () => import('@/components/firms/z56/index.vue'),
    f57: () => import('@/components/firms/z57/index.vue'),
    f58: () => import('@/components/firms/z58/index.vue'),
    f59: () => import('@/components/firms/z59/index.vue'),
    f60: () => import('@/components/firms/z60/index.vue'),
    f61: () => import('@/components/firms/z61/index.vue'),
    f62: () => import('@/components/firms/z62/index.vue'),
    f63: () => import('@/components/firms/z63/index.vue'),
    f64: () => import('@/components/firms/z64/index.vue'),
    f65: () => import('@/components/firms/z65/index.vue'),
    f66: () => import('@/components/firms/z66/index.vue'),
    f67: () => import('@/components/firms/z67/index.vue'),
    f68: () => import('@/components/firms/z68/index.vue'),
    f69: () => import('@/components/firms/z69/index.vue'),
    f70: () => import('@/components/firms/z70/index.vue'),
    f71: () => import('@/components/firms/z71/index.vue'),
    f72: () => import('@/components/firms/z72/index.vue'),
    f73: () => import('@/components/firms/z73/index.vue'),
    f74: () => import('@/components/firms/z74/index.vue'),
    f75: () => import('@/components/firms/z75/index.vue'),
    f76: () => import('@/components/firms/z76/index.vue'),
    f77: () => import('@/components/firms/z77/index.vue'),
    f78: () => import('@/components/firms/z78/index.vue'),
    f79: () => import('@/components/firms/z79/index.vue'),
    f80: () => import('@/components/firms/z80/index.vue'),
    f81: () => import('@/components/firms/z81/index.vue'),
    f82: () => import('@/components/firms/z82/index.vue'),
    f83: () => import('@/components/firms/z83/index.vue'),
    f84: () => import('@/components/firms/z84/index.vue'),
    f85: () => import('@/components/firms/z85/index.vue'),
    f86: () => import('@/components/firms/z86/index.vue'),
    f87: () => import('@/components/firms/z87/index.vue'),
    f88: () => import('@/components/firms/z88/index.vue'),
}

export const firmsList = [
    {
        img: gm("shoplogo/zs_logo_1.jpg"),
        name: "zs_logo_1",
    },
    {
        img: gm("shoplogo/zs_logo_2.jpg"),
        name: "zs_logo_2",
    },
    {
        img: gm("shoplogo/zs_logo_3.jpg"),
        name: "zs_logo_3",
    },
    {
        img: gm("shoplogo/zs_logo_4.jpg"),
        name: "zs_logo_4",
    },
    {
        img: gm("shoplogo/zs_logo_5.jpg"),
        name: "zs_logo_5",
    },
    {
        img: gm("shoplogo/zs_logo_6.jpg"),
        name: "zs_logo_6",
    },
    {
        img: gm("shoplogo/zs_logo_7.jpg"),
        name: "zs_logo_7",
    },
    {
        img: gm("shoplogo/zs_logo_8.jpg"),
        name: "zs_logo_8",
    },
    {
        img: gm("shoplogo/zs_logo_9.jpg"),
        name: "zs_logo_9",
    },
    {
        img: gm("shoplogo/zs_logo_10.jpg"),
        name: "zs_logo_10",
    },
    {
        img: gm("shoplogo/zs_logo_11.jpg"),
        name: "zs_logo_11",
    },
    {
        img: gm("shoplogo/zs_logo_12.jpg"),
        name: "zs_logo_12",
    },
    {
        img: gm("shoplogo/zs_logo_13.jpg"),
        name: "zs_logo_13",
    },
    {
        img: gm("shoplogo/zs_logo_14.jpg"),
        name: "zs_logo_14",
    },
    {
        img: gm("shoplogo/zs_logo_15.jpg"),
        name: "zs_logo_15",
    },
    {
        img: gm("shoplogo/zs_logo_16.jpg"),
        name: "zs_logo_16",
    },
    {
        img: gm("shoplogo/zs_logo_17.jpg"),
        name: "zs_logo_17",
    },
    {
        img: gm("shoplogo/zs_logo_18.jpg"),
        name: "zs_logo_18",
    },
    {
        img: gm("shoplogo/zs_logo_19.jpg"),
        name: "zs_logo_19",
    },
    {
        img: gm("shoplogo/zs_logo_20.jpg"),
        name: "zs_logo_20",
    },
    {
        img: gm("shoplogo/zs_logo_21.jpg"),
        name: "zs_logo_21",
    },
    {
        img: gm("shoplogo/zs_logo_22.jpg"),
        name: "zs_logo_22",
    },
    {
        img: gm("shoplogo/zs_logo_23.jpg"),
        name: "zs_logo_23",
    },
    {
        img: gm("shoplogo/zs_logo_24.jpg"),
        name: "zs_logo_24",
    },
    {
        img: gm("shoplogo/zs_logo_25.jpg"),
        name: "zs_logo_25",
    },
    {
        img: gm("shoplogo/zs_logo_26.jpg"),
        name: "zs_logo_26",
    },
    {
        img: gm("shoplogo/zs_logo_27.jpg"),
        name: "zs_logo_27",
    },
    {
        img: gm("shoplogo/zs_logo_28.jpg"),
        name: "zs_logo_28",
    },
    {
        img: gm("shoplogo/zs_logo_29.jpg"),
        name: "zs_logo_29",
    },
    {
        img: gm("shoplogo/zs_logo_30.jpg"),
        name: "zs_logo_30",
    },
    {
        img: gm("shoplogo/zs_logo_31.jpg"),
        name: "zs_logo_31",
    },
    {
        img: gm("shoplogo/zs_logo_32.jpg"),
        name: "zs_logo_32",
    },
    {
        img: gm("shoplogo/zs_logo_33.jpg"),
        name: "zs_logo_33",
    },
    {
        img: gm("shoplogo/zs_logo_34.jpg"),
        name: "zs_logo_34",
    },
    {
        img: gm("shoplogo/zs_logo_35.jpg"),
        name: "zs_logo_35",
    },
    {
        img: gm("shoplogo/zs_logo_36.jpg"),
        name: "zs_logo_36",
    },
    {
        img: gm("shoplogo/zs_logo_37.jpg"),
        name: "zs_logo_37",
    },
    {
        img: gm("shoplogo/zs_logo_38.jpg"),
        name: "zs_logo_38",
    },
    {
        img: gm("shoplogo/zs_logo_39.jpg"),
        name: "zs_logo_39",
    },
    {
        img: gm("shoplogo/zs_logo_40.jpg"),
        name: "zs_logo_40",
    },
    {
        img: gm("shoplogo/zs_logo_41.jpg"),
        name: "zs_logo_41",
    },
    {
        img: gm("shoplogo/zs_logo_42.jpg"),
        name: "zs_logo_42",
    },
    {
        img: gm("shoplogo/zs_logo_43.jpg"),
        name: "zs_logo_43",
    },
    {
        img: gm("shoplogo/zs_logo_44.jpg"),
        name: "zs_logo_44",
    },
    {
        img: gm("shoplogo/zs_logo_45.jpg"),
        name: "zs_logo_45",
    },
    {
        img: gm("shoplogo/zs_logo_46.jpg"),
        name: "zs_logo_46",
    },
    {
        img: gm("shoplogo/zs_logo_47.jpg"),
        name: "zs_logo_47",
    },
    {
        img: gm("shoplogo/zs_logo_48.jpg"),
        name: "zs_logo_48",
    },
    {
        img: gm("shoplogo/zs_logo_49.jpg"),
        name: "zs_logo_49",
    },
    {
        img: gm("shoplogo/zs_logo_50.jpg"),
        name: "zs_logo_50",
    },
    {
        img: gm("shoplogo/zs_logo_51.jpg"),
        name: "zs_logo_51",
    },
    {
        img: gm("shoplogo/zs_logo_52.jpg"),
        name: "zs_logo_52",
    },
    {
        img: gm("shoplogo/zs_logo_53.jpg"),
        name: "zs_logo_53",
    },
    {
        img: gm("shoplogo/zs_logo_54.jpg"),
        name: "zs_logo_54",
    },
    {
        img: gm("shoplogo/zs_logo_55.jpg"),
        name: "zs_logo_55",
    },
    {
        img: gm("shoplogo/zs_logo_56.jpg"),
        name: "zs_logo_56",
    },
    {
        img: gm("shoplogo/zs_logo_57.jpg"),
        name: "zs_logo_57",
    },
    {
        img: gm("shoplogo/zs_logo_58.jpg"),
        name: "zs_logo_58",
    },
    {
        img: gm("shoplogo/zs_logo_59.jpg"),
        name: "zs_logo_59",
    },
    {
        img: gm("shoplogo/zs_logo_60.jpg"),
        name: "zs_logo_60",
    },
    {
        img: gm("shoplogo/zs_logo_61.jpg"),
        name: "zs_logo_61",
    },
    {
        img: gm("shoplogo/zs_logo_62.jpg"),
        name: "zs_logo_62",
    },
    {
        img: gm("shoplogo/zs_logo_63.jpg"),
        name: "zs_logo_63",
    },
    {
        img: gm("shoplogo/zs_logo_64.jpg"),
        name: "zs_logo_64",
    },
    {
        img: gm("shoplogo/zs_logo_65.jpg"),
        name: "zs_logo_65",
    },
    {
        img: gm("shoplogo/zs_logo_66.jpg"),
        name: "zs_logo_66",
    },
    {
        img: gm("shoplogo/zs_logo_67.jpg"),
        name: "zs_logo_67",
    },
    {
        img: gm("shoplogo/zs_logo_68.jpg"),
        name: "zs_logo_68",
    },
    {
        img: gm("shoplogo/zs_logo_69.jpg"),
        name: "zs_logo_69",
    },
    {
        img: gm("shoplogo/zs_logo_70.jpg"),
        name: "zs_logo_70",
    },
    {
        img: gm("shoplogo/zs_logo_71.jpg"),
        name: "zs_logo_71",
    },
    {
        img: gm("shoplogo/zs_logo_72.jpg"),
        name: "zs_logo_72",
    },
    {
        img: gm("shoplogo/zs_logo_73.jpg"),
        name: "zs_logo_73",
    },
    {
        img: gm("shoplogo/zs_logo_74.jpg"),
        name: "zs_logo_74",
    },
    {
        img: gm("shoplogo/zs_logo_75.jpg"),
        name: "zs_logo_75",
    },
    {
        img: gm("shoplogo/zs_logo_76.jpg"),
        name: "zs_logo_76",
    },
    {
        img: gm("shoplogo/zs_logo_77.jpg"),
        name: "zs_logo_77",
    },
    {
        img: gm("shoplogo/zs_logo_78.jpg"),
        name: "zs_logo_78",
    },
    {
        img: gm("shoplogo/zs_logo_79.jpg"),
        name: "zs_logo_79",
    },
    {
        img: gm("shoplogo/zs_logo_80.jpg"),
        name: "zs_logo_80",
    },
    {
        img: gm("shoplogo/zs_logo_81.jpg"),
        name: "zs_logo_81",
    },
    {
        img: gm("shoplogo/zs_logo_82.jpg"),
        name: "zs_logo_82",
    },
    {
        img: gm("shoplogo/zs_logo_83.jpg"),
        name: "zs_logo_83",
    },
    {
        img: gm("shoplogo/zs_logo_84.jpg"),
        name: "zs_logo_84",
    },
    {
        img: gm("shoplogo/zs_logo_85.jpg"),
        name: "zs_logo_85",
    },
    {
        img: gm("shoplogo/zs_logo_86.jpg"),
        name: "zs_logo_86",
    },
    {
        img: gm("shoplogo/zs_logo_87.jpg"),
        name: "zs_logo_87",
    },
    {
        img: gm("shoplogo/zs_logo_88.jpg"),
        name: "zs_logo_88",
    },
    {
        img: gm("shoplogo/zs_logo_89.jpg"),
        name: "zs_logo_89",
    },
    {
        img: gm("shoplogo/zs_logo_90.jpg"),
        name: "zs_logo_90",
    },
    {
        img: gm("shoplogo/zs_logo_91.jpg"),
        name: "zs_logo_91",
    },
    {
        img: gm("shoplogo/zs_logo_92.jpg"),
        name: "zs_logo_92",
    },
    {
        img: gm("shoplogo/zs_logo_93.jpg"),
        name: "zs_logo_93",
    },
    {
        img: gm("shoplogo/zs_logo_94.jpg"),
        name: "zs_logo_94",
    },
    {
        img: gm("shoplogo/zs_logo_95.jpg"),
        name: "zs_logo_95",
    },
    {
        img: gm("shoplogo/zs_logo_96.jpg"),
        name: "zs_logo_96",
    },
    {
        img: gm("shoplogo/zs_logo_97.jpg"),
        name: "zs_logo_97",
    },
    {
        img: gm("shoplogo/zs_logo_98.jpg"),
        name: "zs_logo_98",
    },
    {
        img: gm("shoplogo/zs_logo_99.jpg"),
        name: "zs_logo_99",
    },
    {
        img: gm("shoplogo/zs_logo_100.jpg"),
        name: "zs_logo_100",
    },
    {
        img: gm("shoplogo/zs_logo_101.jpg"),
        name: "zs_logo_101",
    },
    {
        img: gm("shoplogo/zs_logo_102.jpg"),
        name: "zs_logo_102",
    },
    {
        img: gm("shoplogo/zs_logo_103.jpg"),
        name: "zs_logo_103",
    },
    {
        img: gm("shoplogo/zs_logo_104.jpg"),
        name: "zs_logo_104",
    },
    {
        img: gm("shoplogo/zs_logo_105.jpg"),
        name: "zs_logo_105",
    },
    {
        img: gm("shoplogo/zs_logo_106.jpg"),
        name: "zs_logo_106",
    },
    {
        img: gm("shoplogo/zs_logo_107.jpg"),
        name: "zs_logo_107",
    },
    {
        img: gm("shoplogo/zs_logo_108.jpg"),
        name: "zs_logo_108",
    },
    {
        img: gm("shoplogo/zs_logo_109.jpg"),
        name: "zs_logo_109",
    },
    {
        img: gm("shoplogo/zs_logo_110.jpg"),
        name: "zs_logo_110",
    },
    {
        img: gm("shoplogo/zs_logo_111.jpg"),
        name: "zs_logo_111",
    },
    {
        img: gm("shoplogo/zs_logo_112.jpg"),
        name: "zs_logo_112",
    },
    {
        img: gm("shoplogo/zs_logo_113.jpg"),
        name: "zs_logo_113",
    },
    {
        img: gm("shoplogo/zs_logo_114.jpg"),
        name: "zs_logo_114",
    },
    {
        img: gm("shoplogo/zs_logo_115.jpg"),
        name: "zs_logo_115",
    },
    {
        img: gm("shoplogo/zs_logo_116.jpg"),
        name: "zs_logo_116",
    },
    {
        img: gm("shoplogo/zs_logo_117.jpg"),
        name: "zs_logo_117",
    },
    {
        img: gm("shoplogo/zs_logo_118.jpg"),
        name: "zs_logo_118",
    },
    {
        img: gm("shoplogo/zs_logo_119.jpg"),
        name: "zs_logo_119",
    },
    {
        img: gm("shoplogo/zs_logo_120.jpg"),
        name: "zs_logo_120",
    },
    {
        img: gm("shoplogo/zs_logo_121.jpg"),
        name: "zs_logo_121",
    },
    {
        img: gm("shoplogo/zs_logo_122.jpg"),
        name: "zs_logo_122",
    },
    {
        img: gm("shoplogo/zs_logo_123.jpg"),
        name: "zs_logo_123",
    },
    {
        img: gm("shoplogo/zs_logo_124.jpg"),
        name: "zs_logo_124",
    },
    {
        img: gm("shoplogo/zs_logo_125.jpg"),
        name: "zs_logo_125",
    },
    {
        img: gm("shoplogo/zs_logo_126.jpg"),
        name: "zs_logo_126",
    },
    {
        img: gm("shoplogo/zs_logo_127.jpg"),
        name: "zs_logo_127",
    },
    {
        img: gm("shoplogo/zs_logo_128.jpg"),
        name: "zs_logo_128",
    },
    {
        img: gm("shoplogo/zs_logo_129.jpg"),
        name: "zs_logo_129",
    },
    {
        img: gm("shoplogo/zs_logo_130.jpg"),
        name: "zs_logo_130",
    },
    {
        img: gm("shoplogo/zs_logo_131.jpg"),
        name: "zs_logo_131",
    },
    {
        img: gm("shoplogo/zs_logo_132.jpg"),
        name: "zs_logo_132",
    },
    {
        img: gm("shoplogo/zs_logo_133.jpg"),
        name: "zs_logo_133",
    },
    {
        img: gm("shoplogo/zs_logo_134.jpg"),
        name: "zs_logo_134",
    },
    {
        img: gm("shoplogo/zs_logo_135.jpg"),
        name: "zs_logo_135",
    },
    {
        img: gm("shoplogo/zs_logo_136.jpg"),
        name: "zs_logo_136",
    },
    {
        img: gm("shoplogo/zs_logo_137.jpg"),
        name: "zs_logo_137",
    },
    {
        img: gm("shoplogo/zs_logo_138.jpg"),
        name: "zs_logo_138",
    },
    {
        img: gm("shoplogo/zs_logo_139.jpg"),
        name: "zs_logo_139",
    },
    {
        img: gm("shoplogo/zs_logo_140.jpg"),
        name: "zs_logo_140",
    },
    {
        img: gm("shoplogo/zs_logo_141.jpg"),
        name: "zs_logo_141",
    },
    {
        img: gm("shoplogo/zs_logo_142.png"),
        name: "zs_logo_142",
    },
    {
        img: gm("shoplogo/zs_logo_143.jpg"),
        name: "zs_logo_143",
    },
    {
        img: gm("shoplogo/zs_logo_144.jpg"),
        name: "zs_logo_144",
    },
    {
        img: gm("shoplogo/zs_logo_145.jpg"),
        name: "zs_logo_145",
    },
]


export const homeNewList = [
    {
        timer: "2025-04-08",        title: i18n.t("newIndex.line11"),
        subtitle: i18n.t(""),
        img: gm("2025-01.jpg"),
        link: "https://mp.weixin.qq.com/s/g4DUfx84ZCcpvD-9p9bwCg"
    },
    {
        timer: "2025-04-07",        title: i18n.t("newIndex.line12"),
        subtitle: i18n.t(""),
        img: gm("2025-02.jpg"),
        link: "https://mp.weixin.qq.com/s/OEkCtAtLY7lItQ4IKHfZIg"
    },
    {
        timer: "2025-04-04",        title: i18n.t("newIndex.line13"),
        subtitle: i18n.t(""),
        img: gm("2025-03.jpg"),
        link: "https://mp.weixin.qq.com/s/FOKg9UC08w87fwnBX8Id2g"
    },
    {
        timer: "2025-04-03",        title: i18n.t("newIndex.line14"),
        subtitle: i18n.t(""),
        img: gm("2025-04.jpg"),
        link: "https://mp.weixin.qq.com/s/YpmHlwP_Yzq4gMesuHC_HA"
    },
    {
        timer: "2025-04-03",        title: i18n.t("newIndex.line15"),
        subtitle: i18n.t(""),
        img: gm("2025-05.jpg"),
        link: "https://mp.weixin.qq.com/s/q4nwg2IsP8nXXawItOfXjw"
    },
    {
        timer: "2025-04-03",        title: i18n.t("newIndex.line16"),
        subtitle: i18n.t(""),
        img: gm("2025-06.jpg"),
        link: "https://mp.weixin.qq.com/s/F09wRaZmVHAORbZwNXOUuQ"
    },
    {
        timer: "2025-04-02",        title: i18n.t("newIndex.line17"),
        subtitle: i18n.t(""),
        img: gm("2025-07.jpg"),
        link: "https://mp.weixin.qq.com/s/zN_vOtQpaQrCncAUqssVyQ"
    },
    {
        timer: "2025-04-01",        title: i18n.t("newIndex.line18"),
        subtitle: i18n.t(""),
        img: gm("2025-08.jpg"),
        link: "https://mp.weixin.qq.com/s/trCYFQkQfItdTLI-9Yfqow"
    },
    {
        timer: "2025-03-31",        title: i18n.t("newIndex.line19"),
        subtitle: i18n.t(""),
        img: gm("2025-09.jpg"),
        link: "https://mp.weixin.qq.com/s/2-uU6R8UE4_zRcqB_9dfuw"
    },
    {
        timer: "2025-03-31",        title: i18n.t("newIndex.line20"),
        subtitle: i18n.t(""),
        img: gm("2025-10.jpg"),
        link: "https://mp.weixin.qq.com/s/sn4YJAdCLWxblzdNAKE2IA"
    },
    {
        timer: "2025-03-28",        title: i18n.t("newIndex.line21"),
        subtitle: i18n.t(""),
        img: gm("2025-11.jpg"),
        link: "https://mp.weixin.qq.com/s/9YaunTeZDTLbdc0vLjt6WQ"
    },
    {
        timer: "2025-03-27",        title: i18n.t("newIndex.line22"),
        subtitle: i18n.t(""),
        img: gm("2025-12.jpg"),
        link: "https://mp.weixin.qq.com/s/1U0sgUp4bWiIk7WAm_nsmw"
    },
    {
        timer: "2025-03-25",        title: i18n.t("newIndex.line23"),
        subtitle: i18n.t(""),
        img: gm("2025-13.jpg"),
        link: "https://mp.weixin.qq.com/s/EF1ED04tAMpKguSExZly4w"
    },
    {
        timer: "2025-03-25",        title: i18n.t("newIndex.line24"),
        subtitle: i18n.t(""),
        img: gm("2025-14.jpg"),
        link: "https://mp.weixin.qq.com/s/JETBmlZoY9iGGefEUQ9C-w"
    },
    {
        timer: "2025-03-22",        title: i18n.t("newIndex.line25"),
        subtitle: i18n.t(""),
        img: gm("2025-15.jpg"),
        link: "https://mp.weixin.qq.com/s/zKQ69QKjzhihFMMcGE1zsg"
    },
    {
        timer: "2025-03-30",        title: i18n.t("newIndex.line26"),
        subtitle: i18n.t(""),
        img: gm("2025-16.jpg"),
        link: "https://mp.weixin.qq.com/s/vw13-mRpWwa8Ve8MmGI3DQ"
    },
    {
        timer: "2025-03-29",        title: i18n.t("newIndex.line27"),
        subtitle: i18n.t(""),
        img: gm("2025-17.jpg"),
        link: "https://mp.weixin.qq.com/s/5K5FCaaLozDCke64KxL15g"
    },
    {
        timer: "2025-03-26",        title: i18n.t("newIndex.line28"),
        subtitle: i18n.t(""),
        img: gm("2025-18.jpg"),
        link: "https://mp.weixin.qq.com/s/QNkJQi-kGD_RH4bArefswQ"
    },
    {
        timer: "2025-03-07",        title: i18n.t("newIndex.line29"),
        subtitle: i18n.t(""),
        img: gm("2025-19.jpg"),
        link: "https://mp.weixin.qq.com/s/ljD8_h9ruO0rIKCyKTLDig"
    },
    {
        timer: "2025-02-14",        title: i18n.t("newIndex.line30"),
        subtitle: i18n.t(""),
        img: gm("2025-20.jpg"),
        link: "https://mp.weixin.qq.com/s/00fmP1caNOnhYzrg9VL3Uw"
    },
    {
        timer: "2024-12-05",        title: i18n.t("newIndex.line31"),
        subtitle: i18n.t(""),
        img: gm("2025-21.jpg"),
        link: "https://mp.weixin.qq.com/s/RnDYDqAVQBmCwtqA60C_Fw"
    },
    {
        timer: "2024-12-24",        title: i18n.t("newIndex.line32"),
        subtitle: i18n.t(""),
        img: gm("2025-22.jpg"),
        link: "https://mp.weixin.qq.com/s/ALTJrSN938yj8S2cGRv2jQ"
    },
    {
        timer: "2024-12-26",        title: i18n.t("newIndex.line33"),
        subtitle: i18n.t(""),
        img: gm("2025-23.jpg"),
        link: "https://mp.weixin.qq.com/s/f7gpQTTpvMt6TDJpAFJDrA"
    },
    {
        timer: "2024-12-27",        title: i18n.t("newIndex.line34"),
        subtitle: i18n.t(""),
        img: gm("2025-24.jpg"),
        link: "https://mp.weixin.qq.com/s/CqT11yl5la8LlXcIbHML-w"
    },
    {
        timer: "2023-07-10",        title: i18n.t("newIndex.line1"),
        title: i18n.t("newIndex.line2"),
        img: gm("1-2.png"),
        link: "https://mp.weixin.qq.com/s/YTS_9TSOlB1iN9fKtP7pvw"
    },
    {
        timer: "2023-08-10",        title: i18n.t("newIndex.line3"),
        title: i18n.t("newIndex.line4"),
        img: gm("1-3.jpg"),
        link: "https://mp.weixin.qq.com/s/gtL3q3DNcBgqp46NmCW2WQ"
    },
    {
        timer: "2023-08-18",        title: i18n.t("newIndex.line5"),
        title: i18n.t("newIndex.line6"),
        img: gm("1-4.jpg"),
        link: "https://mp.weixin.qq.com/s/sg_m1zSGWARpQcB3yeLcbg"
    },
    {
        timer: "2023-09-21",        title: i18n.t("newIndex.line35"),
        subtitle: i18n.t(""),
        img: gm("2023-01.jpg"),
        link: "https://mp.weixin.qq.com/s/d-RfUGKnop9EhbzXRvoA9Q"
    },
    {
        timer: "2023-09-26",        title: i18n.t("newIndex.line36"),
        subtitle: i18n.t(""),
        img: gm("2023-02.jpg"),
        link: "https://mp.weixin.qq.com/s/MDY0rH1Sl1mIBwFuyMl3Yw"
    },
    {
        timer: "2023-07-10",        title: i18n.t("newIndex.line37"),
        subtitle: i18n.t(""),
        img: gm("2023-03.jpg"),
        link: "https://mp.weixin.qq.com/s/YTS_9TSOlB1iN9fKtP7pvw"
    },
    {
        timer: "2023-09-16",        title: i18n.t("newIndex.line38"),
        subtitle: i18n.t(""),
        img: gm("2023-04.jpg"),
        link: "https://mp.weixin.qq.com/s/QwORfSUjcBTj4rvgqFDsSw"
    },
    {
        timer: "2023-10-10",        title: i18n.t("newIndex.line39"),
        subtitle: i18n.t(""),
        img: gm("2023-05.jpg"),
        link: "https://mp.weixin.qq.com/s/gtL3q3DNcBgqp46NmCW2WQ"
    },
    {
        timer: "2023-10-12",        title: i18n.t("newIndex.line40"),
        subtitle: i18n.t(""),
        img: gm("2023-06.jpg"),
        link: "https://mp.weixin.qq.com/s/cOSmSLpqPwRMgqY7qgDlYA"
    },
    {
        timer: "2023-08-02",        title: i18n.t("newIndex.line41"),
        subtitle: i18n.t(""),
        img: gm("2023-07.jpg"),
        link: "https://mp.weixin.qq.com/s/MPDzTqxTpbnw1EHoh9sDAw"
    },
    {
        timer: "2023-08-23",        title: i18n.t("newIndex.line42"),
        subtitle: i18n.t(""),
        img: gm("2023-08.jpg"),
        link: "https://mp.weixin.qq.com/s/z-RCuO1KjKSGqo91AgFOcQ"
    },
    {
        timer: "2023-08-23",        title: i18n.t("newIndex.line43"),
        subtitle: i18n.t(""),
        img: gm("2023-09.jpg"),
        link: "https://mp.weixin.qq.com/s/iw70GyvQ3WsNnyKD2Yr_SA"
    },
    {
        timer: "2023-10-13",        title: i18n.t("newIndex.line44"),
        subtitle: i18n.t(""),
        img: gm("2023-10.jpg"),
        link: "https://mp.weixin.qq.com/s/oA4gXpbv7lC8r0jlDsJTrQ"
    },
    {
        timer: "2023-10-14",        title: i18n.t("newIndex.line45"),
        subtitle: i18n.t(""),
        img: gm("2023-11.jpg"),
        link: "https://mp.weixin.qq.com/s/02nvHTWWb0ttASZy4QMeIQ"
    }
]





